import { Validator } from 'vee-validate'
import completedRequests from './completedrequests/index.vue';
import pendingRequests from './pendingrequests/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../shared/components/loader'
import Requests from './../../services/requests.service';
import CONSTANT from './../../../shared/constants/constant'
//import otherinformation from './otherinformation/index.vue';

export default {
 name: 'approvalrequest',
 components: {
   //DatePicker,
   'first': pendingRequests,
   'second': completedRequests,
   VueElementLoading
 },
 props: ['selectedEditRowData'],
 data() {
   return {
     currentTab: 'First',
     componentKey:1,
     tabs: [
       { key:'First', value:'Pending Requests' },
       { key:'Second', value:'Completed Requests' },
     ],
     useremail : '',
     isLoading: false,
     useremail : '',
     clientsystemid : '',
     companyshortname : '',
   }
 },
 created:function() {

 },
 computed: {
   // selects all checkbox's option
   currentTabComponent: function () {
     this.componentKey += 1;
     return this.currentTab.toLowerCase()
   }

 },
 mounted() {
   var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.useremail = userdetail.email;
 },
 methods: {


 }
}



// WEBPACK FOOTER //
// ./src/modules/requests/views/approvalrequest/approvalrequest.component.js